import { FiSearch, FiX } from 'react-icons/fi';
import { GlobalSearchResultsList } from './GlobalSearchResultsList';
import { GlobalSearchInitialState } from './GlobalSearchInitialState';
import { useGlobalSearch } from './useGlobalSearch';

const GlobalSearch = () => {
  const {
    query,
    setQuery,
    results,
    loading,
    searchError,
    isOpen,
    setIsOpen,
    activeIndex,
    recentSearches,
    inputRef,
    wrapperRef,
    handleSubmit,
    handleBookClick,
    handleSuggestionClick,
    handleKeyDown,
    clearRecentSearches,
    clearSearch,
  } = useGlobalSearch();

  const showInitialState = query.trim().length < 2;
  const showNoResults =
    !loading && !searchError && query.trim().length >= 2 && results.length === 0;

  return (
    <div ref={wrapperRef} className="relative w-full">
      <form onSubmit={handleSubmit} role="search">
        <label className="relative block">
          <FiSearch
            aria-hidden="true"
            className="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-xl text-orange-600"
          />
          <input
            ref={inputRef}
            type="text"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            onFocus={() => setIsOpen(true)}
            onKeyDown={handleKeyDown}
            placeholder="Find books by Name, Author, Publisher, or ISBN"
            className="h-12 w-full rounded-lg border border-orange-500 bg-white pl-12 pr-12 text-base text-black outline-none placeholder:text-black focus:border-orange-600 focus:ring-1 focus:ring-orange-500"
            autoComplete="off"
            aria-label="Search products by title, author, publisher, ISBN-10 or ISBN-13"
          />
          {query && (
            <button
              type="button"
              onClick={clearSearch}
              className="absolute right-2 top-1/2 flex h-8 w-8 -translate-y-1/2 items-center justify-center text-orange-600 transition-colors hover:text-orange-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-orange-500"
              aria-label="Clear search"
            >
              <FiX aria-hidden="true" className="text-xl" />
            </button>
          )}
        </label>
      </form>

      {isOpen && (
        <div
          role="listbox"
          className="absolute top-full left-0 right-0 mt-1 bg-white border border-gray-200 rounded-lg shadow-xl z-[100] max-h-[70vh] overflow-y-auto"
        >
          <GlobalSearchResultsList
            loading={loading}
            searchError={searchError}
            results={results}
            query={query}
            activeIndex={activeIndex}
            onBookClick={handleBookClick}
            onViewAll={handleSubmit}
            showNoResults={showNoResults}
          />

          {showInitialState && (
            <GlobalSearchInitialState
              recentSearches={recentSearches}
              onClearRecent={clearRecentSearches}
              onSearch={handleSuggestionClick}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default GlobalSearch;
